import yup from '../../../config/yup';

export const canvasReaderValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('canvasReader'),
  delayedRead: yup.boolean(),
  parameterizedBy: yup.string(),
  connectionKey: yup.string(),
  properties: yup.object().shape({
    rootUrl: yup.string().transform((value) => value.trim()),
    path: yup
      .string()
      .required('Path is required')

      .transform((value) => value.trim()),
    accessToken: yup.string().transform((value) => value.trim()),
    pageSize: yup.string().transform((value) => value.trim()),
    count: yup.string().transform((value) => value.trim()),
  }),
});
